import React from "react";

import { cn } from "../lib/utils";
import styles from "./product-size-fields.module.css";

const ProductSizeFields = ({ selectedSize, sizeVariants, updateSelectedSize, theme }) => {
  let selected = selectedSize;

  if (!selected) {
    selected = sizeVariants[0]["name"];
  }

  const isThemePresent = !!theme?.backgroundColor && !!theme?.primaryColor;

  return (
    <div className={styles.productSizeContainer}>
      {/* <div className={styles.sizeHeading}>SIZE</div> */}
      <div className={styles.sizesContainer}>
        {sizeVariants.map((sizeVariant, index) => {
          return (
            <div
              key={index + 1}
              className={cn(
                styles.sizeContainer +
                  " " +
                  (selected === sizeVariant?.name ? styles.selected : ""),
                selected === sizeVariant?.name
                  ? "cursor-pointer border-primary bg-primary text-fontPrimary"
                  : isThemePresent
                    ? "cursor-pointer border-secondary bg-secondary text-fontBackground"
                    : "cursor-pointer border-appGray bg-appGray text-fontBackground",
              )}
              style={
                index === 0
                  ? { marginLeft: 0 }
                  : index === sizeVariants.length - 1
                    ? { marginRight: 0 }
                    : {}
              }
              onClick={() => updateSelectedSize(sizeVariant?.name)}
            >
              {sizeVariant?.name}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProductSizeFields;
